import React from 'react';
import FormattedTokenWei from '@blockcatio/tabby-library/lib/components/FormattedTokenWei';

import { getSigner } from '../utilities/publicKeyCrypto';
import { getTokenListByName } from '../selectors/token';
import getRewardKey from '../utilities/getRewardKey';
import { REDEEMED_CODE_ERROR } from '../constants';

import {
  REWARD_REDEEM_STARTED,
  REWARD_REDEEM_SUBMITTED,
  REWARD_REDEEM_ABORTED,
  REWARD_REDEEM_FAILED,
  REWARD_REDEEM_CONFIRMED,
  REWARD_REDEEM_REJECTED,
} from '../actionTypes';

export const redeemRewardStart = rewardKey => ({
  type: REWARD_REDEEM_STARTED,
  rewardKey,
});

export const redeemRewardSubmitted = (rewardKey, transactionHash) => ({
  type: REWARD_REDEEM_SUBMITTED,
  rewardKey,
  transactionHash,
});

export const redeemRewardAborted = rewardKey => ({
  type: REWARD_REDEEM_ABORTED,
  rewardKey,
});

export const redeemRewardFailed = (rewardKey, error) => ({
  type: REWARD_REDEEM_FAILED,
  rewardKey,
  error,
});

export const redeemRewardCode = (campaignId, rewardNumber, code, gasPrice, viewOptions) => async (
  dispatch,
  getState,
  { tabbyRewards, ethGateway },
) => {
  const {
    account: { address },
  } = getState();
  const tokenList = getTokenListByName(getState());

  const { redeemable, campaign, value } = await tabbyRewards.fetchReward(campaignId, rewardNumber);

  const { token: tokenAddress, signer } = campaign;

  if (!redeemable) {
    throw new Error(REDEEMED_CODE_ERROR);
  }
  if (getSigner(campaignId, rewardNumber, code) !== signer) {
    throw new Error('The code you have entered is not valid');
  }

  const useViewOptions = {
    ...viewOptions,
    title: 'Redeem Code',
    message: (
      <React.Fragment>
        You are about to redeem{' '}
        <FormattedTokenWei amount={value} tokenList={tokenList} tokenAddress={tokenAddress} />{' '}
        tokens.
      </React.Fragment>
    ),
  };
  const rewardKey = getRewardKey(campaignId, rewardNumber);

  return ethGateway.process(getState, {
    create: () =>
      tabbyRewards.redeemRewardTransaction(campaign, rewardNumber, code, address, gasPrice),
    onStart: () => dispatch(redeemRewardStart(rewardKey)),
    onSuccess: transactionHash => dispatch(redeemRewardSubmitted(rewardKey, transactionHash)),
    onError: error => dispatch(redeemRewardFailed(rewardKey, error)),
    onAbort: () => dispatch(redeemRewardAborted(rewardKey)),
    viewOptions: useViewOptions,
  });
};

export const redeemRewardConfirmed = rewardKey => ({
  type: REWARD_REDEEM_CONFIRMED,
  rewardKey,
});

export const redeemRewardRejected = rewardKey => ({
  type: REWARD_REDEEM_REJECTED,
  rewardKey,
});



// WEBPACK FOOTER //
// ./src/actions/redeemReward.js